import { computed, map, type MapStore } from 'nanostores';
import { EndUser, type Activation } from '~/services/versori-api/types';

export class ActivationStore {
  activations: MapStore<Record<string, Activation>> = map({});

  size = computed([this.activations], (activations) => {
    return Object.keys(activations).length;
  });

  constructor() {
    this.activations = map({});
  }

  setActivation(activation: Activation) {
    this.activations.setKey(activation.id, activation);
  }

  setActivations(activations: Activation[]) {
    this.activations.set(
      activations.reduce(
        (acc, activation) => {
          acc[activation.id] = activation;
          return acc;
        },
        {} as Record<string, Activation>
      )
    );
  }

  reset() {
    this.activations.set({} as Record<string, Activation>);
  }
}
